// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"0fa7b4f2","248":"5825ffd7","473":"2e8150fe","487":"eb04d917","504":"32b83cc7","520":"b9e6ce92","525":"4f45af97","585":"0c4dcf51","686":"77b72bd0","870":"ec0c8fa5","885":"ac562f48","895":"d43206c1","918":"4f663f6d","993":"7a67df1d"}[chunkId] + ".chunk.js";
};